import Dialog from '@mui/material/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';

import { closeWarning } from '../../store/slices/feedback';

const useStyles = makeStyles({
    root: {
        width: 301,
        height: 149
    },
    title: {
        marginTop: 22,
        width: "100%",
        fontFamily: "Helvetica",
        fontSize: "17px",
        textAlign: "center",
        color: "#000"
    },
    message: {
        width: "100%",
        height: "17px",
        marginTop: 20,
        fontFamily: "Helvetica",
        fontSize: "14px",
        letterSpacing: "0.61px",
        textAlign: "center",
        color: "#000"
    },
    buttons: {
        marginTop: 26,
        width: "100%",
        borderTop: "solid 1px #d6d6d6",
    }
});

export default ({}) => {
    const classes = useStyles()
    const warning = useSelector(state => state.feedback.warning);
    const { on, message, title, actionTitle, onConfirm } = warning;
    const dispatch = useDispatch()
    const onClose = () => dispatch(closeWarning());
    const onAction = () => {
        onConfirm()
        onClose()
    }
    return (
        <Dialog open={on} onClose={onClose}>
            <div className={classes.root}>
                <div className={classes.title}>{title}</div>
                <div className={classes.message}>{message}</div>
                <div className={classes.buttons}>
                    <Button 
                        onClick={onClose}
                        style={{
                            width: "150px",
                            height: "43px",
                            borderRight: "solid 1px #d6d6d6"
                        }}
                    >
                        Cancel
                    </Button >
                    <Button 
                        style={{
                            width: "150px",
                            height: "43px"
                        }}
                        onClick={onAction}
                    >{actionTitle}</Button>
                </div>
            </div>
        </Dialog>
    )
}